import orderById from './orderById'
import statusLabel from './statusLabel'
import chipStatusColor from './chipStatusColor'

export default {
  orderById,
  statusLabel,
  chipStatusColor,
}
